import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .hefesto-title > h6 {
    font-size: 0.875rem;
    font-weight: normal;
    padding: 0 0.5rem;
    margin-bottom: 0;
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;
